import * as React from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import * as capitalize from 'capitalize';
import {
  IconButton,
  RouteWrapper,
  HeadingSection,
  NoteList,
  Section,
  Permission,
  PaymentUpdateForm,
  PaymentItem,
} from '../../components';
import { getPayment, showError } from '../../redux/actions/payments';

interface Props {
  match: any;
  error: string | boolean;
  dispatch: Function;
}

interface State {
  id: number;
  ready: boolean;
  payment?: any;
  isEditing: boolean;
}

class Route extends React.Component<Props, State> {
  constructor(props) {
    super(props);
    this.state = {
      id: Number(this.props.match.params.id),
      ready: false,
      isEditing: false,
    };
  }

  /**
   * Get the payment
   */
  async componentDidMount() {
    const setError = (error: string) => {
      this.props.dispatch(showError(error));
    };

    const response = await this.props.dispatch(getPayment(this.state.id));
    if (response.error) {
      setError(response.error);
      return;
    }
    if (response.data === null) {
      setError('This payment does not exist');
      return;
    }

    this.setState({ payment: response.data, ready: true });
  }

  render() {
    let heading = '';
    let type = '';
    if (this.state.payment && this.state.payment.booking.contact_name) {
      heading = `by ${this.state.payment.booking.contact_name}`;
    }
    if (this.state.payment && this.state.payment.type) {
      type = this.state.payment.type;
      if (type !== 'BACS') {
        type = capitalize(type.toLowerCase());
      }
    }
    return (
      <RouteWrapper
        requireAuth
        requirePermission="MANAGE_PAYMENTS"
        title={`${type} Payment ${heading}`}
        breadcrumbs={[
          {
            link: '/payments/',
            text: 'Payments',
          },
          {
            link: `/payments/${this.state.id}`,
            text: `Payment ${heading}`,
          },
        ]}
        ready={this.state.ready}
        error={this.props.error}
      >
        <HeadingSection
          title={`${type} Payment ${heading}`}
          controls={[
            <IconButton
              key="back-button"
              icon="undo"
              className="is-default"
              handleClick={() => {
                this.props.dispatch(push('/payments'));
              }}
            >
              Return
            </IconButton>,
            <Permission key="edit" require="MANAGE_UPDATES">
              <IconButton
                handleClick={() => {
                  !this.state.isEditing
                    ? this.setState({ isEditing: true })
                    : this.setState({ isEditing: false });
                }}
                className="is-default"
                icon={!this.state.isEditing ? 'pencil' : 'window-close'}
              >
                {!this.state.isEditing ? 'Edit' : 'Cancel'}
              </IconButton>
            </Permission>,
            <Permission key="delete" require="MANAGE_DELETIONS">
              {!this.state.isEditing && (
                <IconButton
                  link={`/payments/${this.state.id}/delete`}
                  className="is-danger is-outlined"
                  icon="trash"
                >
                  Delete
                </IconButton>
              )}
            </Permission>,
          ]}
        />
        <Section>
          <div className="columns is-multiline">
            <div className="column is-12-desktop is-7-widescreen">
              {this.state.isEditing ? (
                <PaymentUpdateForm
                  id={this.state.id}
                  item={this.state.payment}
                  onUpdate={() => {
                    window.history.back();
                  }}
                />
              ) : (
                <PaymentItem payment={this.state.payment} />
              )}
            </div>
            <div className="column is-12-desktop is-5-widescreen">
              <NoteList resource="payments" id={this.state.id} />
            </div>
          </div>
        </Section>
      </RouteWrapper>
    );
  }
}

const mapStateToProps = ({ payments }) => ({
  error: payments.error,
});

export default connect(mapStateToProps)(Route);
